export const NotFound = () => (
  <section
    className="
      v2-container
      grid gap-2 md:gap-4 
      grid-cols-1 
      sm:grid-cols-2 
      md:grid-cols-2
      lg:grid-cols-3 
      xl:grid-cols-4
    "
  >
    <div className="h-[224px] bg-gradient-to-b from-[#F3F3F7] to-white block rounded-xl" />
    <div className="h-[224px] bg-gradient-to-b from-[#F3F3F7] to-white hidden sm:block rounded-xl" />
    <div className="h-[224px] bg-gradient-to-b from-[#F3F3F7] to-white hidden lg:block rounded-xl" />
    <div className="h-[224px] bg-gradient-to-b from-[#F3F3F7] to-white hidden xl:block rounded-xl" />
    <h1 className="relative -top-14 col-span-full mb-4 text-h3-a text-base-text-primary text-center">
      Nothing Found
    </h1>
    <h3 className="relative -top-14 col-span-full text-caption-md-a text-base-text-tertiary text-center">
      We couldn't find any posts on the chosen topic
    </h3>
  </section>
);
